import { useState, useCallback } from 'react';
import { useTasks } from '../contexts/TaskContext';
import { useAuth } from './useAuth';

export const useTaskOperations = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { addTask: addTaskToContext, updateTask: updateTaskInContext, deleteTask: deleteTaskFromContext, setError } = useTasks();
  const { currentUser } = useAuth();

  const addTask = useCallback(async (taskData) => {
    try {
      setIsLoading(true);
      setError(null);
      
      await addTaskToContext(taskData);
      
    } catch (error) {
      console.error('❌ Error adding task:', error);
      setError('Failed to create task');
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [addTaskToContext, setError]);

  const updateTask = useCallback(async (id, updates) => {
    try {
      setIsLoading(true);
      setError(null);
      
      await updateTaskInContext(id, updates);
    } catch (error) {
      console.error('❌ Error updating task:', error);
      setError('Failed to update task');
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [updateTaskInContext, setError]);

  const deleteTask = useCallback(async (id) => {
    try {
      setIsLoading(true);
      setError(null);
      
      await deleteTaskFromContext(id);
    } catch (error) {
      console.error('❌ Error deleting task:', error);
      setError('Failed to delete task');
      throw error;
    } finally {
      setIsLoading(false);
    }
  }, [deleteTaskFromContext, setError]);

  return {
    addTask,
    updateTask,
    deleteTask,
    isLoading
  };
};